import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconStarFilled = /*@__PURE__*/ proxyCustomElement(class CosmosIconStarFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'fef02eb60ecb35bcff7da7f2f41270de2d2c851b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'bb8eb9f922c94ade7ef498454cf93ffee9a69273', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd1baf937e1404187692976e4ce8e5989ec814ed8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.113 19a.85.85 0 0 0 .426-.16l4.465-2.924 4.465 2.924a.9.9 0 0 0 .427.16c.32 0 .426-.267.293-.711l-1.432-4.942 3.914-3.458c.24-.205.329-.347.329-.525 0-.248-.187-.364-.649-.408l-4.883-.445-1.974-4.995c-.152-.374-.285-.516-.49-.516-.204 0-.346.151-.488.516L8.54 8.51l-4.892.445C3.187 9 3 9.116 3 9.364c0 .178.089.32.329.525l3.922 3.458-1.432 4.942c-.124.453-.017.711.294.711", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-star-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-star-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-star-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStarFilled);
            }
            break;
    } });
}

export { CosmosIconStarFilled as C, defineCustomElement as d };
